import React from 'react';
import { twJoin } from 'tailwind-merge';

type BadgeType = 'badge' | 'text';

export const badgeColorData = {
  yellow: 'bg-yellow5 text-white',
  pink: 'bg-pink4 text-white',
  purple: 'bg-purple4 text-white',
  green: 'bg-green4 text-white',
  red: 'bg-red5 text-white',
  black: 'bg-gray7 text-white',
  gray: 'bg-gray4 text-white',

  lightBlue: 'bg-blue1 text-blue5',
  lightYellow: 'bg-yellow0 text-yellow6',
  lightPink: 'bg-pink0 text-pink4',
  lightPurple: 'bg-purple0 text-purple5',
  lightGreen: 'bg-green0 text-green6',
  lightRed: 'bg-red0 text-red5',
  lightBlack: 'bg-gray0 text-gray8',
  lightGray: 'bg-gray0 text-gray4',
} as const;

export const textColorData = {
  yellow: 'text-yellow6',
  pink: 'text-pink4',
  purple: 'text-purple5',
  green: 'text-green6',
  red: 'text-red5',
  black: 'text-gray5',
  gray: 'text-gray4',
};

const textDotColorData = {
  yellow: 'bg-yellow6',
  pink: 'bg-pink4',
  purple: 'bg-purple5',
  green: 'bg-green6',
  red: 'bg-red5',
  black: 'bg-gray5',
  gray: 'bg-gray4',
};

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: BadgeType;
  badgeColor?: keyof typeof badgeColorData;
  textBadgeColor?: keyof typeof textColorData;
}

function Badge({
  type = 'badge',
  badgeColor = 'yellow',
  textBadgeColor = 'yellow',
  ...props
}: BadgeProps) {
  const { className, ...rest } = props;

  const renderBadge = () => {
    if (type === 'badge') {
      return (
        <div
          className={twJoin(
            'inline-flex items-center rounded-full border-none px-[10px] py-0.5 text-b12m',
            badgeColorData[badgeColor],
            className,
          )}
          {...rest}
        />
      );
    }

    return (
      <div
        className={twJoin(
          `inline-flex items-center gap-x-1 ${textColorData[textBadgeColor]}`,
          className,
        )}
        {...rest}
      >
        <figure
          className={twJoin(
            'h-[8px] w-[8px] rounded-full',
            textDotColorData[textBadgeColor],
          )}
        />
        {props.children}
      </div>
    );
  };

  return renderBadge();
}

export default Badge;
